import {Dispatch} from "redux";

import {catch404} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";

import {IPropertyDetailApplication} from "../../property/types/IPropertyDetailApplication";
import {getApplicationPropertyDetailById} from "../api/get_application_property_detail_by_id";

const APPLICATION_PROPERTY_DETAIL_PREFIX = "desktop/application/property_detail/fetch";
export const getApplicationPropertyDetailTypes = createRequestActionTypes(APPLICATION_PROPERTY_DETAIL_PREFIX);

export const getApplicationPropertyDetail =
    (propertyId: number, applicationId: string) =>
    (dispatch: Dispatch): Promise<IPropertyDetailApplication | void> => {
        dispatch({type: getApplicationPropertyDetailTypes.start, id: applicationId});

        return getApplicationPropertyDetailById(propertyId)
            .then((json) => {
                dispatch({type: getApplicationPropertyDetailTypes.success, result: json, id: applicationId});
                return json;
            })
            .catch(
                catch404(() => {
                    dispatch({type: getApplicationPropertyDetailTypes.error, id: applicationId});
                })
            );
    };

export const resetApplicationPropertyDetail = () => ({type: getApplicationPropertyDetailTypes.reset});
import {Dispatch} from "redux";

import {catch404} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";

import {IPropertyDetailApplication} from "../../property/types/IPropertyDetailApplication";
import {getApplicationPropertyDetailById} from "../api/get_application_property_detail_by_id";

const APPLICATION_PROPERTY_DETAIL_PREFIX = "desktop/application/property_detail/fetch";
export const getApplicationPropertyDetailTypes = createRequestActionTypes(APPLICATION_PROPERTY_DETAIL_PREFIX);

export const getApplicationPropertyDetail =
    (propertyId: number, applicationId: string) =>
    (dispatch: Dispatch): Promise<IPropertyDetailApplication | void> => {
        dispatch({type: getApplicationPropertyDetailTypes.start, id: applicationId});

        return getApplicationPropertyDetailById(propertyId)
            .then((json) => {
                dispatch({type: getApplicationPropertyDetailTypes.success, result: json, id: applicationId});
                return json;
            })
            .catch(
                catch404(() => {
                    dispatch({type: getApplicationPropertyDetailTypes.error, id: applicationId});
                })
            );
    };

export const resetApplicationPropertyDetail = () => ({type: getApplicationPropertyDetailTypes.reset});
